/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyRequestStatusEnum } from './loyaltyRequestStatusEnum';
import { LoyaltyRequestChangeDtoView } from './loyaltyRequestChangeDtoView';


/**
 * Вернуть заявку в ПЛ.
 */
export interface LoyaltyRequestDtoFullView { 
    /**
     * название любимого места.
     */
    name: string;
    /**
     * город и местоположение места.
     */
    location: string;
    /**
     * ссылка на карту.
     */
    mapLink?: string;
    /**
     * ссылки на сайт или соцсети.
     */
    webLink?: string;
    /**
     * почему хочет скидку.
     */
    reasonText?: string;
    /**
     * готов рассказать о PremiumCode.
     */
    readyToPromote?: boolean;
    /**
     * контакты для связи.
     */
    userContactsText?: string;
    /**
     * Контакт директора или менеджера, если известен
     */
    managerContact?: string;
    /**
     * ID записи.
     */
    id?: string;
    /**
     * ID пользователя.
     */
    userId?: string;
    /**
     * ID объединения автора.
     */
    parentOrganisationId?: string;
    /**
     * имя объединения автора.
     */
    parentOrganisationName?: string;
    /**
     * ID дефолтной организации автора.
     */
    organisationId?: string;
    /**
     * имя дефолтной организации автора.
     */
    organisationName?: string;
    /**
     * Дата создания.
     */
    createdDate?: string;
    /**
     * Дата редактирования.
     */
    modifiedDate?: string;
    status?: LoyaltyRequestStatusEnum;
    /**
     * Список правок.
     */
    changes?: Array<LoyaltyRequestChangeDtoView>;
}
export namespace LoyaltyRequestDtoFullView {
}


